var anchor;
export default function (url) {
    if (!anchor)
        anchor = document.createElement("a");
    anchor.href = url;
    if (!anchor.protocol)
        anchor.protocol = document.location.protocol;
    if (!anchor.host)
        anchor.host = document.location.host;
    return anchor;
}
;
//# sourceMappingURL=parseUrl.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/misc/parseUrl.js
// module id = 55
// module chunks = 1